import { selectGetAdminSession } from "features/admin/presentation/slices/get-admin-session.slice";
import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { pusher } from "features/shared/constants";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { stockUserNotification } from "../slices/user-notification.slice";

interface TransactionParam {
  userId: Array<{ first_name: string; id: string; last_name: string }>;
  message: string;
}
export function StockNotificationWrapper() {
  const dispatch = useAppDispatch();
  const getAdminSessionState = useAppSelector(selectGetAdminSession);

  useEffect(() => {
    pusher.unsubscribe("stock-user-notification");
    const userNotificationChannel = pusher.subscribe("stock-user-notification");

    userNotificationChannel.bind(
      "user-notification",
      (data: TransactionParam) => {
        if (
          data.userId.find(
            (user) => user.id === getAdminSessionState.data?.admin.user_id
          )
        ) {
          dispatch(stockUserNotification());
        }
      }
    );
  }, [getAdminSessionState, dispatch]);

  return <Outlet />;
}
